import type { FC, PropsWithChildren } from 'react';
import { useAppSelector } from 'store';
import { usersSelectors } from 'store/slices';
import type { User } from 'types/users';
import { UserRoles } from 'types/users';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'common/types';

export const AdminPrivateRoute: FC<PropsWithChildren> = ({ children }) => {
  const isUserAuthenticated = useAppSelector(usersSelectors.selectToken);
  const navigate = useNavigate();
  const profile = useAppSelector(usersSelectors.selectProfile) as User;
  if (!isUserAuthenticated || (profile && profile.role === UserRoles.CLIENT)) {
    navigate(AppRoutes.HOME);
  }

  return <>{children}</>;
};
